const GameCreationTabs = Object.freeze({
  SET_UP: 'set_up',
  GAME_RULES: 'game_rules',
  CONTENT_ASSETS: 'content_assets',
  PRIZES: 'prizes',
  PREVIEW_LAUNCH: 'preview_launch',
  ANALYTICS: 'analytics'
})

const GameCreationSubSteps = Object.freeze({
  BASIC_SET_UP: 'basic_set_up',
  COMPETITION_TEAMS: 'competition_teams',
  BRACKET_BUILDER: 'bracket_builder',
  ROUNDS_AND_PREDICTIONS: 'rounds_and_predictions',
  SCORING: 'scoring',
  CONTENT: 'content',
  ASSETS: 'assets',
  PRIZES: 'prizes',
  PREVIEW: 'preview',
  LAUNCH: 'launch',
  PLAY_HISTORY: 'play_history',
  FIXTURES: 'fixtures'
})

const GameCreationSubStepId = Object.freeze({
  [GameCreationSubSteps.BASIC_SET_UP]: 1,
  [GameCreationSubSteps.COMPETITION_TEAMS]: 2,
  [GameCreationSubSteps.ROUNDS_AND_PREDICTIONS]: 3,
  [GameCreationSubSteps.SCORING]: 4,
  [GameCreationSubSteps.CONTENT]: 5,
  [GameCreationSubSteps.ASSETS]: 6,
  [GameCreationSubSteps.PRIZES]: 7,
  [GameCreationSubSteps.PREVIEW]: 8,
  [GameCreationSubSteps.LAUNCH]: 9,
  [GameCreationSubSteps.PLAY_HISTORY]: 10,
  [GameCreationSubSteps.FIXTURES]: 11,
  [GameCreationSubSteps.BRACKET_BUILDER]: 12
})

const GameCreationTabSubStepsMap = Object.freeze({
  [GameCreationTabs.SET_UP]: [
    GameCreationSubSteps.BASIC_SET_UP,
    GameCreationSubSteps.COMPETITION_TEAMS,
    GameCreationSubSteps.BRACKET_BUILDER
  ],
  [GameCreationTabs.GAME_RULES]: [
    GameCreationSubSteps.ROUNDS_AND_PREDICTIONS,
    GameCreationSubSteps.SCORING
  ],
  [GameCreationTabs.CONTENT_ASSETS]: [
    GameCreationSubSteps.CONTENT,
    GameCreationSubSteps.ASSETS
  ],
  [GameCreationTabs.PRIZES]: [GameCreationSubSteps.PRIZES],
  [GameCreationTabs.PREVIEW_LAUNCH]: [
    GameCreationSubSteps.PREVIEW,
    GameCreationSubSteps.LAUNCH
  ],
  [GameCreationTabs.ANALYTICS]: [
    GameCreationSubSteps.PLAY_HISTORY,
    GameCreationSubSteps.FIXTURES
  ]
})

const BracketPredictorGameSpecificSteps = Object.freeze([
  GameCreationSubSteps.COMPETITION_TEAMS
])

const ManualBracketPredictorGameSpecificSteps = Object.freeze([
  GameCreationSubSteps.BRACKET_BUILDER
])

export {
  GameCreationTabs,
  GameCreationSubSteps,
  GameCreationTabSubStepsMap,
  BracketPredictorGameSpecificSteps,
  GameCreationSubStepId,
  ManualBracketPredictorGameSpecificSteps
}



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameCreationStepsEnum.js